import { Contract } from 'pricing/types';

export const buildContractsWithTotalQuantity = (contracts: Contract[]): Contract[] => {
  return contracts.map((contract) => {
    const totalQuantity =
      contract.breederContractTerms.reduce((prev, curr) => prev + curr.quantity, 0) || [];

    return { ...contract, totalQuantity: totalQuantity };
  }) as Contract[];
};
